import { useEffect } from "react";
import { Link } from "react-router-dom";
import TermsContent from "@/components/TermsContent";
import Logo from "@/components/Logo";
import LanguageSwitcher from "@/components/LanguageSwitcher";
import { t } from "@/lib/i18n";

export default function Terms() {
  useEffect(() => window.scrollTo(0, 0), []);
  return (
    <div className="min-h-screen bg-white">
      <header className="h-16 border-b flex items-center px-6 md:px-12">
        <Link to="/" className="flex items-center gap-2">
          <Logo className="text-2xl" />
        </Link>
        <div className="ml-auto"><LanguageSwitcher compact /></div>
      </header>
      <main className="max-w-3xl mx-auto px-6 md:px-12 py-12">
        <p className="font-mono text-xs uppercase tracking-[0.2em] text-amber-700">{t("Legal")}</p>
        <h1 className="font-display font-black text-3xl sm:text-4xl mt-2 mb-8">{t("Terms & Conditions and Privacy Policy")}</h1>
        <TermsContent />
      </main>
    </div>
  );
}
